import { Component } from '@angular/core';
import { CompanyCode } from '@shared/enums/company-code';
import { ViewHandlerComponent } from '@shared/view-handler/view-handler.component';
import { BrandedLoginComponent } from '../branded-login/branded-login.component';
import { TeacherLoginComponent } from '../login.teacher/login.teacher.component';

@Component({
  selector: 'zbp-login-user-handler',
  template: '<ng-container *ngComponentOutlet="componentToUse | async"></ng-container>',
  standalone: false
})
export class LoginUserHandlerComponent extends ViewHandlerComponent {
  componentMap = {
    [CompanyCode.HighlightsPortal]: {
      component: BrandedLoginComponent,
    },
    [CompanyCode.ZBPortal]: {
      component: TeacherLoginComponent,
    },
    ZbRedesign: {
      component: BrandedLoginComponent,
    }
  };
}
